import * as React from "react";
const SvgFiRrCircleB = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-b_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m3.561-10.836A3.5 3.5 0 0 0 16 9.514a3.67 3.67 0 0 0-1.063-2.645 3.67 3.67 0 0 0-2.63-1.101h-2.269c-1.654 0-3 1.346-3 3v6.5c0 1.654 1.346 3 3 3h4.23a3.7 3.7 0 0 0 2.657-1.112 3.7 3.7 0 0 0 1.074-2.657 3.505 3.505 0 0 0-2.439-3.336zM9.039 8.769c0-.551.449-1 1-1h2.269c.457 0 .885.179 1.205.504s.494.756.487 1.212a1.54 1.54 0 0 1-1.536 1.514H9.038zm6.463 6.984a1.72 1.72 0 0 1-1.233.516h-4.23c-.551 0-1-.449-1-1V13h5.462c.826 0 1.499.673 1.499 1.514.007.466-.17.906-.498 1.239"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-b_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleB;
